const RED_STYLE = 'color:red;font-weight:bold;'
const PARAGRAPH_STYLE = 'margin:0 0 8px;'
const LAST_PARAGRAPH_STYLE = 'margin:0;'

export function red(text) {
  return '<span style="' + RED_STYLE + '">' + text + '</span>'
}

export function p(text, last = false) {
  return '<p style="' + (last ? LAST_PARAGRAPH_STYLE : PARAGRAPH_STYLE) + '">' + text + '</p>'
}

export function br() {
  return '<br/>'
}

export function joinTips(parts) {
  return (parts || []).filter(Boolean).join('')
}



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstTip.js